import { render, staticRenderFns } from "./MyArticle.vue?vue&type=template&id=69050527&scoped=true&"
import script from "./MyArticle.vue?vue&type=script&lang=js&"
export * from "./MyArticle.vue?vue&type=script&lang=js&"
import style0 from "./MyArticle.vue?vue&type=style&index=0&id=69050527&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69050527",
  null
  
)

export default component.exports